import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { api } from "../lib/api";
import { useLang } from "../context/LangContext";

export default function Orders() {
  const { t, lang, isRTL } = useLang();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    api.get("/orders").then(({ data }) => setOrders(data));
  }, []);

  return (
    <main data-testid="orders-page" className="max-w-4xl mx-auto px-6 md:px-10 py-10 md:py-14">
      <h1 className="font-display text-4xl mb-8">{t("orderHistory")}</h1>
      {orders.length === 0 ? (
        <div className="py-16 text-center text-[#767676]" data-testid="orders-empty">
          {lang === "ar" ? "لا توجد طلبات بعد." : "No orders yet."}
        </div>
      ) : (
        <div className="space-y-4">
          {orders.map((o) => (
            <Link
              key={o.id}
              to={`/orders/${o.id}`}
              className="block border border-[#E5E1D8] rounded-md bg-white p-5 hover:border-[#1A1738] transition-colors"
              data-testid={`order-${o.id}`}
            >
              <div className="flex items-baseline justify-between gap-4 flex-wrap">
                <div>
                  <div className="text-[10px] uppercase tracking-widest text-[#7B5CBF]">
                    {t("order")} <span className="font-mono normal-case ms-1">{o.order_number}</span>
                  </div>
                  <div className="text-xs text-[#767676] mt-1">
                    {new Date(o.created_at).toLocaleString()}
                  </div>
                </div>
                <div className="text-end">
                  <div className="font-medium">${o.total.toFixed(2)}</div>
                  <div className="text-[10px] uppercase tracking-widest text-[#4d7c4d]">{o.status}</div>
                </div>
              </div>
              <div className="mt-4 text-sm text-[#1A1738] space-y-1">
                {o.items.map((it) => (
                  <div key={it.product_id} className="flex justify-between">
                    <span className="truncate pe-2">
                      {(lang === "ar" ? it.product?.name_ar : it.product?.name_en) || ""} × {it.quantity}
                    </span>
                    <span className="shrink-0">${it.line_total.toFixed(2)}</span>
                  </div>
                ))}
              </div>
              <div className="mt-4 flex items-center justify-end text-xs uppercase tracking-widest text-[#1A1738] hover-underline w-fit ms-auto" data-testid={`track-${o.id}`}>
                {lang === "ar" ? "تتبع" : "Track order"}
                <ChevronRight className={`h-3.5 w-3.5 ms-1 ${isRTL ? "rotate-180" : ""}`} strokeWidth={1.5} />
              </div>
            </Link>
          ))}
        </div>
      )}
    </main>
  );
}
